import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/cn"

const badgeVariants = cva(
    "inline-flex items-center gap-1.5 rounded-full border border-border-default px-2.5 py-1 text-xs font-medium leading-none transition-colors focus:outline-none focus:ring-1 focus:ring-inset focus:ring-brand-primary focus:ring-offset-0 focus:border-brand-primary",
    {
        variants: {
            variant: {
                neutral: "bg-surface-raised text-text-muted border-border-default",
                info: "bg-state-info-subtle text-state-info border-transparent",
                success: "bg-state-success-subtle text-state-success border-transparent",
                warning: "bg-state-warning-subtle text-state-warning border-transparent",
                danger: "bg-state-danger-subtle text-state-danger border-transparent",
                // Brand "category accent" used for blog category pills + Directory filter chips.
                category: "bg-brand-primary/10 text-brand-primary border-brand-primary/20",
            },
        },
        defaultVariants: {
            variant: "neutral",
        },
    }
)

export interface BadgeProps
    extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> { }

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
    ({ className, variant, ...props }, ref) => {
        return (
            <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />
        )
    }
)
Badge.displayName = "Badge"

export { Badge, badgeVariants }
